// Vendors
import { useLayoutEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useAppInformationContextConsumerHook } from 'contexts/app-information.context';
import { useAppContextConsumerHook } from 'contexts/app.context';
// Event Handlers
import { CheckoutHandlers } from '../handlers/checkout.handlers';
import { LogHandlers } from 'handlers/log.handlers';

const useCheckoutHook = (): void => {
  const { showBoundary: setError } = useErrorBoundary(),
    { setCheckoutOrderData, setCallbackUrl, setCustomerName, setLoanId } =
      useAppContextConsumerHook(),
    { setInformationFlags, informationFlags } = useAppInformationContextConsumerHook();

  const { handleSendCustomActionEvent } = LogHandlers(),
    { handleFetchCheckoutOrderData } = CheckoutHandlers({
      handleSendCustomActionEvent,
      informationFlags,
      setCallbackUrl,
      setCheckoutOrderData,
      setCustomerName,
      setError,
      setInformationFlags,
      setLoanId,
    });

  useLayoutEffect(() => {
    handleFetchCheckoutOrderData();
  }, [informationFlags]);
};

export { useCheckoutHook };
